import React from 'react';
import "./products.css";


 import paas from "../../assets/images/products/paas-img.svg"
import sbp from "../../assets/images/products/sbp-img.svg"


const Products = () => {
  return (
   <section id='products'>
    
     <div className='container main-products'>
           <div className='row products-content'>
                 <div className='col-lg-6 col-md-6 col-sm-12 products12'>
                    <h2 className='products-main-title'>Products</h2>
                </div>
            </div>
          
           <div className='row products-text-main products-bottom-line products-column-reverse'>  
          
           <div className='col-lg-5 col-md-5 col-sm-12 products-col'>
             <h4 className='products-subtitle products-subtitle--preserve-case'>CryptoCPU</h4>
                     

                       <p>RISC-V based CPU for vectorized post-quantum processing - enabling fast, cost-efficient, and scalable zero-knowledge proofs without migration overhead.</p>

                       

           </div>
            <div className='col-lg-4 col-md-4 col-sm-12 products-col-img'>
               <img className='products-img-paas' src={paas} alt="paas" />
           </div>
             
             
              
            </div>
            
            
             <div className='row products-text-main'> 

                 <div className='col-lg-4 col-md-4 col-sm-12 products-col-img'>
               <img className='products-img-sbp' src={sbp} alt="sbp" /> 
                    
                    
            
             </div> 
             
             <div className='col-lg-5 col-md-5 col-sm-12 products-col'>
                   <h4 className='products-subtitle'>Post-Quantum Cryptographic IP Components</h4>

              <p>A portfolio of cryptographic IPs covering the fundamental building blocks of post-quantum schemes, including hash functions and NTT-based lattice arithmetic, delivering best-in-class performance, area, and energy efficiency, and enabling cost-optimized integration into FPGAs and ASICs for security-critical systems.</p>
              
             </div>
              
             

            </div>
            
        </div>
   </section>
  )
}

export default Products
